<script>
  import {
    currentLessonIndex,
    activeLesson,
    pageToLoad,
    lessons,
  } from "../scripts/stores.js";
  import { activeLessonUnsub } from "../scripts/firebase.js";
  import { onDestroy } from "svelte";

  export let currentLesson;

  const activeLessonUnsubLocal = activeLessonUnsub(currentLesson);

  $: console.log($activeLesson);

  console.log("inside LessonContent");

  const increment = () => {
    console.log("increment");
    currentLesson.isComplete = true;
    currentLessonIndex.set(currentLesson.lessonIndex + 1);
  };

  const complete = () => {
    currentLesson.isComplete = true;
    pageToLoad.set("workshopHome");
  };

  onDestroy(() => {
    console.log("destroying component");
    activeLessonUnsubLocal();
  });
</script>

<main>
  {#if $activeLesson}
    <h1>{$activeLesson.title}</h1>
    <div class="iframe-container">
      <iframe
        width="560"
        height="315"
        src={$activeLesson.videoURL}
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
    <p>{$activeLesson.text}</p>
    {#if currentLesson.isComplete}
      <div class="complete">Lesson Complete!</div>
      <div
        class="link-internal"
        on:click={() => {
          currentLessonIndex.set(currentLesson.lessonIndex + 1);
        }}
      >
        Next
      </div>
    {:else if currentLesson.lessonIndex == $lessons.length - 1}
      <div class="button-primary" on:click={complete}>Complete Workshop!</div>
    {:else}
      <div class="button-primary" on:click={increment}>Mark Complete</div>
    {/if}
  {:else}
    <p>loading...</p>
  {/if}
</main>

<style>
  .iframe-container {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
  }
  .iframe-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .complete {
    background-color: #00f10033;
    padding: 10px;
    outline: solid 1px #ffffffaa;
    outline-offset: -5px;
    box-sizing: border-box;
    text-align: center;
  }

  .link-internal {
    text-align: center;
  }

  h1 {
    text-align: center;
  }
</style>
